import { Component, Prop, toNative, Vue } from '@natureos/vue-facing-decorator';

@Component
class Tag extends Vue {
  @Prop({ default: null })
  public readonly value!: string | null;
}

export default toNative(Tag);
export { default as Tag } from './tag.component.vue';
